var render = function render(){var _vm=this,_c=_vm._self._c;return _c('photo-validation-error-modal',{attrs:{"name":"photo-unsupported-format-modal","title":_vm.$t('photoValidation.title.notAnImage'),"error-message":_vm.$t('photoValidation.text.notAnImage')}})
}
var staticRenderFns = []

export { render, staticRenderFns }